import * as React from 'react'

import { Trash2Icon } from 'lucide-react'
import { observer } from 'mobx-react'

import { IInstructions, PermitFieldType } from '~/client/graph'
import { Button } from '~/client/src/shared/components/Button/Button'
import Localization from '~/client/src/shared/localization/LocalizationManager'
import { getBullet } from '~/client/src/shared/utils/PermitInstructionsHelper'

import BaseInstructionsConfigurator from '../BaseInstructionsConfigurator/BaseInstructionsConfigurator'
import InstructionTextHolder from '../BaseInstructionsConfigurator/InstructionTextHolder'
import InstructionsStore from './Instructions.store'

interface IProps {
  instructions: IInstructions
  onChange: (instruction: IInstructions) => void
  className?: string
}

@observer
export default class Instructions extends React.Component<IProps> {
  private readonly store: InstructionsStore = null

  public constructor(props: IProps) {
    super(props)

    this.store = new InstructionsStore(props.instructions, props.onChange)
  }

  public render() {
    const { instructions, onChange, className } = this.props

    return (
      <BaseInstructionsConfigurator<string>
        className={className}
        instructions={instructions}
        onChange={onChange}
        store={this.store}
        instructionItemRenderer={this.renderInstructionItem}
        fieldType={PermitFieldType.Instructions}
      />
    )
  }

  private renderInstructionItem = (item: string, index: number) => {
    const {
      handleMouseEnter,
      handleMouseLeave,
      instructions: { listType },
      hoveredInstructionIndex,
      tryToRemoveInstruction,
    } = this.store

    return (
      <div
        key={index}
        className="row y-start relative instruction-item mb15 tw:pr-8"
        onMouseEnter={handleMouseEnter.bind(null, index)}
        onMouseLeave={handleMouseLeave}
      >
        <span className="text large bold blue-highlight no-grow mr12">
          {getBullet(listType, index + 1)}
        </span>
        <InstructionTextHolder<string>
          instructionText={item}
          instructionIndex={index}
          store={this.store}
        />
        {hoveredInstructionIndex === index && (
          <Button
            variant="destructive-ghost"
            size="icon-sm"
            className="del-icon tw:absolute tw:right-0 tw:-top-1"
            aria-label={Localization.translator.delete}
            onClick={tryToRemoveInstruction.bind(null, index)}
          >
            <Trash2Icon />
          </Button>
        )}
      </div>
    )
  }
}
